/**
 * This hooks allows to retrieve the different documentation strings present in a
 * SubTemplateFieldValue.
 */
import type { Optional } from '@festina-life/core'

import type { SubTemplateFieldValue } from '../../types/templateModel'

export const subTemplatedFieldValueDocumentation = (
  variant: Optional<SubTemplateFieldValue>,
) => {
  if (!variant) {
    return null
  }

  const modelFieldTypeDocumentation = variant.type?.documentation

  const configurationFieldDocumentation = variant.documentation
  const modelFieldTypeName = variant.modelType?.typeName

  return {
    modelFieldTypeDocumentation,
    modelFieldType: modelFieldTypeName ?? '-',
    configurationFieldDocumentation,
    configurationFieldDocumentationPath: `${variant.path}.documentation`,
  }
}
